export default __webpack_public_path__ + "static/media/icons-bar-next-normal.4062693c.svg";